import { authConstants } from 'constants/index';

export default {
  [authConstants.KEY_CURRENT_USER]: null,
  [authConstants.KEY_CURRENT_PERMISSIONS]: null,
};
